export const enum ServiceTypes {
  Azure = 'azure',
  BitBucket = 'bitbucket',
  GitHub = 'github',
  GitLab = 'gitlab',
  Jira = 'jira'
}
